import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-ghost',
    templateUrl: './ghost.component.html',
    styleUrls: ['./ghost.component.scss'],
    standalone: false
})
export class GhostComponent  {
  @Input() ghost;
}
